import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

export const citySlice = createSlice({
  name: 'city',
  initialState: {
    selectedCity: JSON.parse(localStorage.getItem('selectedCity') || "{}") || null,
    cityData: JSON.parse(
      localStorage.getItem('cityData') || "{}"
    ) || null,
  },
  reducers: {
    setSelectedCity: (state, action) => {
      state.selectedCity = action.payload;
    },
    setCityData: (state, action) => {
      state.cityData = action.payload;
    },
  },
});

export const { setSelectedCity,setCityData } = citySlice.actions;

export const selectCity = (state: RootState) => state.city.selectedCity;
export const selectCityData = (state: RootState) =>  state.city.cityData;
export default citySlice.reducer;